import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import ContactForm from './ContactForm';
import { usePopup } from '../context/PopupContext';

const PopupModal = () => {
  const { isOpen, openPopup, closePopup } = usePopup();

  // Auto-popup disabled - popup will only open when user clicks "Get Started" buttons
  // useEffect(() => {
  //   // Check if popup has been shown in this session
  //   const popupShown = sessionStorage.getItem('popupShown');
  //   
  //   if (!popupShown) {
  //     // Show popup after 3 seconds
  //     const timer = setTimeout(() => {
  //       openPopup();
  //       sessionStorage.setItem('popupShown', 'true');
  //     }, 3000);
  //
  //     return () => clearTimeout(timer);
  //   }
  // }, [openPopup]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm animate-in fade-in duration-300 overflow-y-auto">
      <div className="min-h-screen flex items-center justify-center p-2 sm:p-4">
        <div className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full my-4 sm:my-8 animate-in zoom-in duration-300 max-h-[96vh] flex flex-col">
          {/* Close Button */}
          <button
            onClick={closePopup}
            className="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 bg-white/90 hover:bg-white rounded-full p-1.5 transition-all duration-300 hover:scale-110 shadow-lg"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-[#2C3E50]" />
          </button>

        <div className="grid grid-cols-1 md:grid-cols-2 md:overflow-y-auto md:max-h-[96vh] rounded-2xl">
          {/* Left Side - Image (Hidden on small screens) */}
          <div className="hidden md:block relative h-auto bg-gradient-to-br from-[#C0392B] to-[#A93226] overflow-hidden md:min-h-[600px]">
            <div className="absolute inset-0">
              <img
                src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85"
                alt="Contact us"
                className="w-full h-full object-cover opacity-30"
              />
            </div>
            <div className="relative z-10 h-full flex flex-col justify-center p-8 text-white">
              <h2 className="text-3xl font-bold mb-3">
                Start Your Trademark Registration!
              </h2>
              <p className="text-base text-white/90 mb-4">
                Get expert legal assistance for just $45. Our team will contact you within 24 hours.
              </p>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                  <span className="text-sm">Fast Processing</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                  <span className="text-sm">98% Success Rate</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                  <span className="text-sm">Expert Support</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Form (Full width on mobile, half width on desktop) */}
          <div className="p-4 sm:p-6 md:p-8 bg-white rounded-2xl md:rounded-l-none">
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#2C3E50] mb-2">Get Started</h3>
            <p className="text-xs sm:text-sm text-[#7F8C8D] mb-4">Fill out the form below to begin your trademark registration</p>
            <ContactForm onSuccess={closePopup} isCompact={true} />
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
